export default function HeroSection() {
  const scrollToSection = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/b43099ae9d368cc04adbb5d85d2a4f13.jpg"
          alt="크로아티아 청정 자연"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/20 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full text-center px-5 max-w-4xl mx-auto hero-animate">
        <p className="text-[#C4A882] text-xs font-medium tracking-[0.3em] uppercase mb-4 md:mb-6">
          Croatia Premium Wellness
        </p>
        <h1 className="text-white text-4xl sm:text-5xl lg:text-7xl font-light leading-tight mb-5 md:mb-6">
          순수한 자연이<br />전하는 웰니스의 본질
        </h1>
        <p className="text-white/80 text-base lg:text-xl font-light leading-relaxed mb-8 md:mb-10 max-w-2xl mx-auto">
          크로아티아 청정 자연에서 채취한 천연 지올라이트.<br />
          위딘은 자연의 치유력을 담아 당신의 건강한 삶을 완성합니다.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => scrollToSection('#products')}
            className="bg-white/15 text-white border border-white/50 backdrop-blur-sm px-8 py-4 rounded-full text-base font-medium hover:bg-white/25 transition-all duration-300 cursor-pointer whitespace-nowrap min-w-[160px]"
          >
            제품 보기
          </button>
          <button
            onClick={() => scrollToSection('#purchase')}
            className="bg-[#8B7355] text-white px-8 py-4 rounded-full text-base font-semibold hover:bg-[#7A6245] transition-all duration-300 cursor-pointer whitespace-nowrap min-w-[160px] flex items-center justify-center gap-2 shadow-lg shadow-black/30"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-shopping-bag-line text-base"></i>
            </div>
            지금 구매하기
          </button>
        </div>
      </div>

      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white/60 text-2xl"></i>
      </div>

      <div className="absolute bottom-0 left-0 w-full z-10">
        <div className="grid grid-cols-3 sm:grid-cols-5 bg-black/50 backdrop-blur-md py-4 sm:py-5 px-4 sm:px-6 gap-y-4">
          {[
            { icon: "ri-leaf-line", label: "100% 천연 원료" },
            { icon: "ri-flask-line", label: "과학적으로 검증" },
            { icon: "ri-shield-check-line", label: "순도 테스트 완료" },
            { icon: "ri-focus-3-line", label: "활성화 입자" },
            { icon: "ri-drop-line", label: "다기능 미네랄" },
          ].map((item) => (
            <div key={item.label} className="flex flex-col items-center gap-1.5 sm:gap-2">
              <div className="w-9 h-9 sm:w-11 sm:h-11 flex items-center justify-center rounded-full border border-white/70 bg-white/20">
                <i className={`${item.icon} text-white text-base sm:text-xl`}></i>
              </div>
              <p className="text-white text-[10px] sm:text-xs tracking-wider whitespace-nowrap font-medium">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
